import BaseBulletPoint from "./BaseBulletPoint.vue";

export default BaseBulletPoint;
